import type { SxProps, Theme } from '@mui/material/styles';

type RegistrationDetailStyleMap = {
    loadingContainer: SxProps<Theme>
    notFoundContainer: SxProps<Theme>
    notFoundButton: SxProps<Theme>
    actionButtons: SxProps<Theme>
    root: SxProps<Theme>
    header: SxProps<Theme>
    headerLeft: SxProps<Theme>
    card: SxProps<Theme>
    cardHeader: SxProps<Theme>
    bottomActions: SxProps<Theme>
    dialogActions: SxProps<Theme>
};

type VehicleRegistrationRowStyleMap = {
    vinBadge: SxProps<Theme>
    warrantySelect: SxProps<Theme>
    row: SxProps<Theme>
};

export const registrationDetailStyles: RegistrationDetailStyleMap = {
    loadingContainer: { display: 'flex', justifyContent: 'center', py: 8 },
    notFoundContainer: { py: 8, textAlign: 'center' },
    notFoundButton: { mt: 2 },
    actionButtons: { display: 'flex', gap: 1.5, flexWrap: 'wrap' },
    root: { display: 'flex', flexDirection: 'column', gap: 3 },
    header: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: 2 },
    headerLeft: { display: 'flex', alignItems: 'center', gap: 2 },
    card: { border: '1px solid', borderColor: 'divider', borderRadius: 2, overflow: 'hidden' },
    cardHeader: { px: 3, py: 2, borderBottom: '1px solid', borderColor: 'divider', display: 'flex', justifyContent: 'space-between', alignItems: 'center' },
    bottomActions: { display: 'flex', justifyContent: 'flex-end' },
    dialogActions: { px: 3, pb: 2 },
};

export const vehicleRegistrationRowStyles: VehicleRegistrationRowStyleMap = {
    vinBadge: { bgcolor: 'grey.50', px: 1, py: 0.5, borderRadius: 0.5, display: 'inline-block' },
    warrantySelect: { minWidth: 200 },
    row: { px: 3, py: 2.5, display: 'grid', gridTemplateColumns: '160px 1fr', gap: 2, alignItems: 'start' },
};
